import { createContext, useContext, useState } from "react";

const LeadCtx = createContext(null);

export function LeadProvider({ children, value }) {
  return <LeadCtx.Provider value={value}>{children}</LeadCtx.Provider>;
}

export function useLead() {
  return useContext(LeadCtx);
}

export function useLeadState() {
  const [open, setOpen] = useState(false);
  const [interest, setInterest] = useState("quote");
  const openLead = (type = "quote") => {
    setInterest(type);
    setOpen(true);
  };
  return { open, setOpen, interest, setInterest, openLead };
}
